// src/utils/storage.js
import { getStorage, ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";

/**
 * Upload a file to Firebase Storage and return its metadata.
 * @param {File} file
 * @param {string} userId
 * @param {string} assignmentId
 * @returns {Promise<{name: string, url: string, type: string}>}
 */
export const uploadAssignmentFile = (file, userId, assignmentId) => {
  const storage = getStorage();
  const filePath = `submissions/${userId}/${assignmentId}/${file.name}`;
  const storageRef = ref(storage, filePath);

  return new Promise((resolve, reject) => {
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      'state_changed',
      null,
      (error) => {
        console.error("Upload failed:", error);
        reject(error);
      },
      async () => {
        try {
          // Use storageRef from closure — reliable across all SDK versions
          const downloadUrl = await getDownloadURL(storageRef);
          resolve({ name: file.name, url: downloadUrl, type: file.type });
        } catch (urlError) {
          reject(urlError);
        }
      }
    );
  });
};

/**
 * Delete a file from Firebase Storage.
 * @param {string} userId
 * @param {string} assignmentId
 * @param {string} fileName
 * @returns {Promise<boolean>}
 */
export const deleteFile = async (userId, assignmentId, fileName) => {
  const storage = getStorage();
  const fileRef = ref(storage, `submissions/${userId}/${assignmentId}/${fileName}`);

  try {
    await deleteObject(fileRef);
    return true;
  } catch (error) {
    console.error("Error deleting file:", error);
    return false;
  }
};